/**
 * Created by craser on 5/4/15.
 * @constructor
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplAndroid = function() {
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplResize.call(this);

};
$hxClasses.extend(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplResize, com.inq.flash.client.chatskins.ChatTextFocusMonitorImplAndroid, 'com.inq.flash.client.chatskins.ChatTextFocusMonitorImplAndroid');



com.inq.flash.client.chatskins.ChatTextFocusMonitorImplAndroid.prototype.FixIPhoneFocusScroll = function() {
	return false;
};